import { Search as SearchIcon } from "@/assets/icons/24/Search";
import { SearchBox } from "@/features/search/components/search-box/SearchBox";
import { useSearchBoxContext } from "@/features/search/components/search-box/search-box.context";
import { useSuggestions } from "@/features/search/hooks/useSuggestions";
import { splitOnTypedPrefix } from "@/features/search/utils/highlight.utils";

/**
 * Query suggestions from the search service — the queries other people actually ran. With an empty
 * field the service answers with the trending ones, so this section carries the initial state too.
 */
export const SearchBoxSuggestions = () => {
  const { term, open } = useSearchBoxContext();
  const suggestions = useSuggestions(term, open);

  const typedTerm = term.trim().toLowerCase();

  return (
    <>
      {suggestions
        /* The typed term already leads the list as its own row — don't repeat it. */
        .filter(suggestion => suggestion.text.toLowerCase() !== typedTerm)
        .map(suggestion => {
          const { typed, completion } = splitOnTypedPrefix(
            suggestion.text,
            term
          );

          return (
            <SearchBox.Item
              key={suggestion.text}
              value={`suggestion:${suggestion.text}`}
              term={suggestion.text}
              icon={<SearchIcon className="size-5" />}
            >
              <span className="text-grey-500">{typed}</span>
              {completion}
            </SearchBox.Item>
          );
        })}
    </>
  );
};
